import React, { useState } from "react";
import * as S from "../styles";

type Props = {
  campos: string[];
  onChange: (campos: string[]) => void;
};

const CamposRemoverSection: React.FC<Props> = ({ campos, onChange }) => {
  const [novoCampo, setNovoCampo] = useState("");
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editCampo, setEditCampo] = useState("");

  const handleAdd = (): void => {
    if (!novoCampo.trim()) return;
    if (campos.includes(novoCampo.trim())) return;
    onChange([...campos, novoCampo.trim()]);
    setNovoCampo("");
  };

  const handleRemove = (index: number): void => {
    onChange(campos.filter((_, i) => i !== index));
    if (editIndex === index) setEditIndex(null);
  };

  const handleStartEdit = (index: number): void => {
    setEditIndex(index);
    setEditCampo(campos[index]);
  };

  const handleSaveEdit = (): void => {
    if (editIndex === null || !editCampo.trim()) return;
    const updated = [...campos];
    updated[editIndex] = editCampo.trim();
    onChange(updated);
    setEditIndex(null);
  };

  const handleCancelEdit = (): void => {
    setEditIndex(null);
  };

  return (
    <S.SectionCard>
      <S.SectionTitle>Campos a Remover</S.SectionTitle>
      <S.InfoBox>
        ℹ️ Campos listados aqui serão <strong>removidos</strong> do JSON antes do envio à integração.
        Use quando a prefeitura rejeita uma tag enviada por padrão. Ex: <code>servico[].codigoNbs</code>
      </S.InfoBox>

      {campos.length > 0 && (
        <S.Table>
          <thead>
            <tr>
              <th>Caminho</th>
              <th aria-label="Ações" />
            </tr>
          </thead>
          <tbody>
            {campos.map((campo, i) => (
              editIndex === i ? (
                <tr key={`r-edit-${i}`}>
                  <td><S.FormInput value={editCampo} onChange={(e) => setEditCampo(e.target.value)} style={{ minWidth: 150 }} /></td>
                  <td>
                    <S.IconButton type="button" onClick={handleSaveEdit}>✅</S.IconButton>
                    <S.IconButton type="button" onClick={handleCancelEdit}>❌</S.IconButton>
                  </td>
                </tr>
              ) : (
                <tr key={`r-${campo}-${i}`}>
                  <td><code>{campo}</code></td>
                  <td>
                    <S.IconButton type="button" onClick={() => handleStartEdit(i)}>✏️</S.IconButton>
                    <S.IconButton type="button" onClick={() => handleRemove(i)}>🗑️</S.IconButton>
                  </td>
                </tr>
              )
            ))}
          </tbody>
        </S.Table>
      )}

      <S.FormRow>
        <S.FormInput
          placeholder="Caminho do campo (ex: servico[].codigoNbs)"
          value={novoCampo}
          onChange={(e) => setNovoCampo(e.target.value)}
          onKeyPress={(e) => { if (e.key === "Enter") handleAdd(); }}
        />
        <S.SmallButton type="button" onClick={handleAdd}>+ Adicionar</S.SmallButton>
      </S.FormRow>
    </S.SectionCard>
  );
};

export default CamposRemoverSection;
